/* eslint-disable no-unused-vars */

import { useLocation, useNavigate } from 'react-router-dom';
import './FinalSize.css';
import "@fontsource/libre-baskerville";

// Brand-level built-in toe allowances (cm)
const BRAND_TOE_ALLOWANCE = {
  NIKE: 0.5,
  ADIDAS: 0.4,
  HM: 0.7,
  ZARA: 0.6
};


export const TOE_SPACE = 0.7;        // cm — required toe clearance
export const WIDTH_ALLOWANCE = 0.2;  // cm — socks + natural spread

export function getTargetFootprint(measurements) {
  if (!measurements?.footLength || !measurements?.footWidth) {
    return null;
  }

  return {
    // Foot + toe space = required INNER shoe length
    targetLength: measurements.footLength + TOE_SPACE,

    // Foot + comfort allowance = required INNER shoe width
    targetWidth: measurements.footWidth + WIDTH_ALLOWANCE
  };
}



function FinalSize() {
  const { state } = useLocation();
  const navigate = useNavigate();

  const {
    baseStillSizes = [],   // [{ brand, theirSize, baseSize }]
    manualFootLength = null,
    footShape = '',
    footWidth = {},
    avgLength = null
  } = state || {};

  const widthCategory = footWidth.category || '';
  const manualWidth = footWidth.manualCm || null;
  const estimatedWidth = footWidth.estimatedCm || null;

  // --- Compute TRUE FOOT LENGTH ---
  let footLength = null;

  if (avgLength && baseStillSizes.length > 0) {
    const corrected = baseStillSizes
      .map(({ brand, baseSize }) => {
        const allowance = BRAND_TOE_ALLOWANCE[brand] ?? 0.7;
        return baseSize ? baseSize - allowance : null;
      })
      .filter(Boolean);

    if (corrected.length) {
      footLength =
        Math.round(
          (corrected.reduce((a, b) => a + b, 0) / corrected.length) * 10
        ) / 10;
    }
  } else if (manualFootLength) {
    footLength = manualFootLength;
  }

  const finalWidth = manualWidth || estimatedWidth || null;

  const handleSaveToLocalStorage = () => {
    if (!footLength || !finalWidth) return;

    const measurementData = {
      footLength,
      footWidth: finalWidth,
      widthCategory,
      footShape
    };

    localStorage.setItem(
      "shushMeasurement",
      JSON.stringify(measurementData)
    );

    navigate('/shop');
  };

  return (
    <div className="final-container">
      <h1 className="final-title">Your Foot Measurements</h1>

      <div className="size-card">
        <p>
          Foot Length: <strong>{footLength} cm</strong>
        </p>

        <p>
          Foot Width:{' '}
          <strong>
            {finalWidth
              ? `${finalWidth} cm (${widthCategory})`
              : widthCategory}
          </strong>
        </p>

        <p>
          Foot Shape: <strong>{footShape}</strong>
        </p>

        <hr />
      </div>

      <div className="final-buttons">
        <button
          className="start-over-btn"
          onClick={() => navigate('/size-guide')}
        >
          Start Over
        </button>

        <button
          className="save-btn"
          onClick={handleSaveToLocalStorage}
        >
          Let’s check your fit →
        </button>
      </div>
    </div>
  );
}

export default FinalSize;
